import React, { useMemo, useState } from "react";
import { Spinner, Table } from "react-bootstrap";

import { useRequest } from "@components/AppHook";
import { Awesome } from "@components/Helpers";
import { arrayMove } from "@components/Utils";
import { DndContext } from "@dnd-kit/core";
import { SortableContext, useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";

const TrSortable = ({ id, sortingId, rendered_tds }) => {
    const { attributes, listeners, setNodeRef, transform, transition } = useSortable({
        id,
    });

    const style = {
        transform: CSS.Translate.toString(transform),
        transition,
    };

    return (
        <tr ref={setNodeRef} style={style}>
            <td style={{ width: "30px" }} {...listeners} {...attributes}>
                {id === sortingId ? (
                    <Spinner animation="border" variant="primary" size="sm" />
                ) : (
                    <Awesome type="bars" />
                )}
            </td>
            {rendered_tds}
        </tr>
    );
};

export const DndTable = ({
    apiData,
    setApiData,
    apiUrl,
    postAction = "rearrange",
    listName = "object_list",
    ths,
    tds,
}) => {
    const [sortingId, setSortingId] = useState(null);
    const object_list = apiData ? apiData[listName] : [];
    const itemIds = useMemo(() => object_list?.map((item) => item.id), [apiData]);
    const { api_post } = useRequest();

    const onSortEnd = (event) => {
        const { active, over } = event;
        if (active.id !== over.id) {
            const newIndex = object_list.findIndex((item) => item.id === over.id);
            const oldIndex = object_list.findIndex((item) => item.id === active.id);
            const new_list = arrayMove(object_list, oldIndex, newIndex);
            const ids = new_list.map((o) => o.id);

            setApiData((prev) => ({ ...prev, [listName]: new_list }));

            setSortingId(active.id);

            api_post(null, apiUrl, {
                params: { action: postAction, ids },
                finally: () => setSortingId(null),
            });
        }
    };
    return (
        <DndContext onDragEnd={onSortEnd}>
            <Table hover responsive className="dmg-table">
                {ths && (
                    <thead>
                        <tr>
                            <th />
                            {ths}
                        </tr>
                    </thead>
                )}
                <tbody>
                    <SortableContext items={itemIds}>
                        {object_list?.map((el) => (
                            <TrSortable id={el.id} key={el.id} sortingId={sortingId} rendered_tds={tds(el)} />
                        ))}
                    </SortableContext>
                </tbody>
            </Table>
        </DndContext>
    );
};
